import design from "../img/serviceImages/design.webp";
import healthcare from "../img/serviceImages/healthcare.webp";
import construction from "../img/serviceImages/construction.webp";
import drywall from "../img/serviceImages/drywall.webp";
import consulting from "../img/serviceImages/consulting.webp";
import bim from "../img/serviceImages/bim.webp";

export const serviceImages = { design, healthcare, construction, drywall, consulting, bim };
